import ridershipService from '@/modules/Flexigo/services/ridershipService';

/**
 * Downloads the ridership Excel report (the Shuttle Detailed Trips Report) for a date range, narrowed to routes and a
 * direction. The dashboard charts' Excel exports all use it.
 * @param {{ startDay: number, endDay: number, routeIds?: number[], direction?: string }} params YYYYMMDD days; no
 *   routeIds means every route
 * @returns {Promise<void>}
 */
export default async function downloadRidershipReport({ startDay, endDay, routeIds, direction }) {
  const blob = await ridershipService.exportExcel({
    startDay,
    endDay,
    direction,
    routeIds: routeIds?.length ? routeIds : undefined,
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `ridership_${startDay}_${endDay}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
}
